var map = {
  "./icon--arrow-right.svg": "8854",
  "./icon--chevron-down.svg": "7674",
  "./icon--close.svg": "1864",
  "./icon--download.svg": "2764",
  "./icon--external.svg": "8321",
  "./icon--facebook.svg": "1672",
  "./icon--instagram.svg": "1952",
  "./icon--link.svg": "1972",
  "./icon--linkedin.svg": "6730",
  "./icon--mail.svg": "105",
  "./icon--menu.svg": "5289",
  "./icon--quote.svg": "9936",
  "./icon--search.svg": "3512",
  "./icon--share.svg": "5421",
  "./icon--speak.svg": "4414",
  "./icon--whatsapp.svg": "9238",
  "./icon--x.svg": "2708",
  "./icon--youtube.svg": "1119"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 3813;
